import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';
import Icon from '@/assets/icons/communiq-logo-text-blue.svg?react';
import background from '@/assets/images/communiq-bubbles-bg.svg?react';

export const LogoCont = styled.div`
  display: flex;
  height: 100vh;

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[5]} url(${background}) no-repeat center/cover;
  `}
`;

export const LogoIcon = styled(Icon)`
  width: 200px;
  height: 200px;
`;

export const ChildrenCont = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
